export type OverviewView = 'scenarios' | 'costBreakdown' | 'demandGroups';

/** Maps the URL path segment (`$view`) to the internal view key, and back. */
const VIEW_BY_PATH: Record<string, OverviewView> = {
    scenarios: 'scenarios',
    'cost-breakdown': 'costBreakdown',
    'demand-groups': 'demandGroups',
};
export const PATH_BY_VIEW: Record<OverviewView, string> = {
    scenarios: 'scenarios',
    costBreakdown: 'cost-breakdown',
    demandGroups: 'demand-groups',
};

/** The view an `/overview/$view` path segment names, or `undefined` for one the page doesn't know. */
export function parseOverviewView(path: string): OverviewView | undefined {
    // `hasOwn`, so that `constructor` or `toString` don't find `Object.prototype`'s members.
    return Object.hasOwn(VIEW_BY_PATH, path) ? VIEW_BY_PATH[path] : undefined;
}
